import React from "react";
import { motion } from "framer-motion";
import { cn } from "../../../utils/cn";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  animated?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className,
  animated = true,
}) => {
  const cardContent = (
    <div
      className={cn(
        "bg-white lg:rounded-xl lg:shadow-lg lg:border lg:border-gray-100 overflow-visible",
        className,
      )}
    >
      {children}
    </div>
  );

  if (animated) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {cardContent}
      </motion.div>
    );
  }

  return cardContent;
};

export default Card;
